import {
  Auth,
  EmailAuthProvider,
  FacebookAuthProvider,
  GoogleAuthProvider,
  User,
  getAuth,
  reauthenticateWithCredential,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut,
  updatePassword,
  updateProfile
} from 'firebase/auth'
import { firebaseConfig } from './firebase'
import { initializeApp } from 'firebase/app'
import { notifyAuthStateChanged } from './firebaseObserver'
export { getIdToken as lazyGetIdToken } from 'firebase/auth'

let _auth: Promise<Auth>
export async function lazyGetAuth(): Promise<Auth> {
  const config = firebaseConfig
  if (_auth) {
    return _auth
  }

  if (!config) {
    throw new Error('Ithaca Error: must call initIthaca first')
  }

  _auth = new Promise<Auth>(resolve => {
    const firebaseApp = initializeApp(config)
    const auth = getAuth(firebaseApp)
    auth.onAuthStateChanged(user => notifyAuthStateChanged(user))
    resolve(auth)
  })

  return _auth
}

export async function lazySignInWithGoogle(_: string, scopes?: string[]): Promise<User> {
  const auth = await lazyGetAuth()
  const googleProvider = new GoogleAuthProvider()
  scopes?.forEach(scope => {
    googleProvider.addScope(scope)
  })
  const userCredential = await signInWithPopup(auth, googleProvider)
  return userCredential.user
}

export async function lazySignInWithFacebook(_: string): Promise<User> {
  const auth = await lazyGetAuth()
  const facebookProvider = new FacebookAuthProvider()
  const userCredential = await signInWithPopup(auth, facebookProvider)
  return userCredential.user
}

export async function lazySignInWithEmailAndPassword({
  email,
  password
}: {
  email: string
  password: string
}): Promise<User> {
  const auth = await lazyGetAuth()
  const userCredential = await signInWithEmailAndPassword(auth, email, password)
  return userCredential.user
}

export async function lazySignOut(): Promise<void> {
  const auth = await lazyGetAuth()
  await signOut(auth)
}

export async function lazyGetUser(): Promise<User | null> {
  const auth = await lazyGetAuth()
  return auth.currentUser
}

export async function lazyUpdateUserName(name: string): Promise<void> {
  const user = await lazyGetUser()
  if (!user) {
    throw new Error('user not found')
  } else {
    await updateProfile(user, { displayName: name })
  }
}

export async function lazyReauthenticateWithEmailAndPassword({
  email,
  password
}: {
  email: string
  password: string
}): Promise<void> {
  const user = await lazyGetUser()
  if (!user) {
    throw new Error('user not found')
  } else {
    const credential = EmailAuthProvider.credential(email, password)
    reauthenticateWithCredential(user, credential)
  }
}

export async function lazyUpdatePassword(password: string): Promise<void> {
  const user = await lazyGetUser()
  if (!user) {
    throw new Error('user not found')
  } else {
    return updatePassword(user, password)
  }
}
